import React, { Component } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import PropTypes from 'prop-types'
import { checkTrackingBesideBarcodeFBA } from '../../../services/api/apiNextBox'
import { pushNewItemHistory } from "../../../services/api/apiItemHistory"
import ModalError from "./notication/ModalError"

class NextBoxFBAInput extends Component {
    constructor(props) {
        super(props)

        this.state = {
            barcode: '',
            submitted: false,
            arrBarcodes: [],
            arrTracking: '',
            messageErr: '',
            dataError: [],
            loading: false,
            isOpen: false,
            error: '',
            isOpenError: false
        }
    }

    _handleOnChange = e => {
        const { value } = e.target
        const { submitted } = this.state

        if (submitted) {
            this.setState({
                barcode: value,
                submitted: false,
                arrBarcodes: [],
                arrTracking: '',
                messageErr: '',
                dataError: [],
            })
        } else {
            this.setState({
                barcode: value,
            })
        }
    }

    _handleSubmit = async e => {
        e.preventDefault()

        const { box } = this.props
        const { id: boxNumber } = Object.assign({}, box)
        const { arrBarcodes, barcode } = this.state
        const arrString = barcode.split("-")
        const newStr = arrString[arrString.length - 1]
        const check = /^#([0-9]{6,})_([0-9]+)?$/.test(newStr.trim())

        if (check) {
            arrBarcodes.push(newStr.trim())
            this.setState({
                arrBarcodes,
                barcode: '',
                messageErr: '',
                error: '',
            }, async () => {
                const { box } = this.props
                try {
                    const payload = {
                        barCodes: this.state.arrBarcodes
                    }
                    const { data, success: successParent, message } = await checkTrackingBesideBarcodeFBA(box._id, payload)

                    if (!successParent) {
                        return this.setState({
                            submitted: true,
                            loading: false
                        }, () => {
                            this.setState({
                                barcode: '',
                                isOpenError: true,
                                error: message
                            })
                        })
                    }

                    const { result } = data

                    this.setState({
                        submitted: true,
                        loading: false,
                        isOpen: true
                    }, () => {
                        const { onRefresh } = this.props
                        onRefresh()

                        const { item_number, item_index } = result
                        return pushNewItemHistory(`${item_number}_${item_index}`, {
                            event_key: 'scan_to_package',
                            event_description: 'Scan QR to package.',
                            event_meta: {
                                box_number: '#' + boxNumber,
                            }
                        })
                    })

                } catch (err) {
                    this.setState({
                        submitted: true,
                        loading: false
                    })
                    window.alert(err.message)
                }
            })
        } else {
            this.setState({
                barcode: '',
                isOpenError: true,
                error: 'Bạn đã nhập sai Barcode vui lòng kiểm tra lại. Định dạng đúng ex: #123456_1'
            })
        }
    }

    _onClosePopup = () => {
        this.setState({
            isOpen: false,
            isOpenError: false
        })
    }

    render() {
        const { box } = this.props
        const {
            arrBarcodes,
            arrTracking,
            dataError,
            totalSuccess,
            loading,
            isOpen,
            barcode,
            error,
            isOpenError,
            submitted,
        } = this.state
        const { status } = box

        if (status !== 'opening') return null

        return (
            <div className="NextBoxInput mt-3">
                <form className="mb-3" onSubmit={this._handleSubmit}>
                    <div className="form-group">
                        <label>
                            <b>*</b> Bạn quét(nhập) vào mã <b>Barcode</b>.
                        </label>
                        <input
                            type="text"
                            className="BoxInput form-control"
                            value={barcode}
                            placeholder="Quét QR"
                            autoFocus
                            onChange={this._handleOnChange}
                        />

                        {loading && <i className="fa fa-spinner fa-spin" />}
                    </div>
                </form>

                <div className="d-flex align-item-center justify-content-between">
                    <div>
                        {arrBarcodes.length > 0 && <h6>Thông tin đã nhập/quét vào:</h6>}

                        <div className='d-flex align-items-center mb-2'>
                            {
                                arrBarcodes.length > 0 && (
                                    <div className="barCodes">
                                        <label className="mr-3 mb-0"><strong>Barcodes:</strong></label>
                                        {
                                            arrBarcodes.map((item, index) => {
                                                return (
                                                    <span className="mr-3" key={index}>{item}</span>
                                                )
                                            })
                                        }
                                    </div>
                                )
                            }
                        </div>

                        {
                            arrTracking !== '' && (
                                <div className="barCodes">
                                    <label className="mr-3"><strong>Traking number:</strong></label>
                                    {arrTracking}
                                </div>
                            )
                        }
                    </div>
                    {(submitted && !error) &&
                        <div className='TAG_SUCCESS'>
                            <div
                                className="text-success font-weight-bold text-center py-1 px-5 bg-white"
                                style={{ fontSize: 37, border: '4px solid' }}
                            >
                                THÀNH CÔNG
                            </div>
                        </div>
                    }

                    <div className="totalSuccess">
                        {totalSuccess > 0 &&
                            <>
                                <strong>{totalSuccess}</strong> sản phẩm được đóng thùng
                            </>
                        }
                    </div>
                </div>

                <ModalError isOpen={isOpenError} onClose={this._onClosePopup} error={error} dataError={dataError} isOpenDataErr={isOpen} onClosePopup={this._onClosePopup} />

            </div>
        )
    }
}

NextBoxFBAInput.propTypes = {
    box: PropTypes.object.isRequired,
    onRefresh: PropTypes.func.isRequired,
}

export default NextBoxFBAInput
